import {DestroyRef, inject, Injectable} from '@angular/core';
import {Subscription} from 'rxjs';
import {WindowWidgetsService} from '../../window-widgets/window-widgets.service';

@Injectable({providedIn: 'root'})
export class DualModeLifecycleManager {
    private destroyRef = inject(DestroyRef, {optional: true}); // null in popup
    private subs: Subscription[] = [];

    constructor(private widgetsSvc?: WindowWidgetsService) {
        const isExternal = !!(window.opener && window.opener !== window);

        if (isExternal) {
            widgetsSvc?.registerBeforeUnload(this.cleanup);
        } else if (this.destroyRef) {
            this.destroyRef.onDestroy(this.cleanup);
        }
    }

    track(s: Subscription) {
        console.log(`track ${s}`);
        this.subs.push(s);
        if (this.destroyRef) {
            console.log('this.destroyRef.onDestroy');
            this.destroyRef.onDestroy(() => s.unsubscribe());
        }
    }

    private cleanup = () => {
        console.log('clean up');
        this.subs.forEach(s => s.unsubscribe());
        this.subs.length = 0;
    };
}
